import React from 'react'
import Home from './Home'
import Register from './Companents/Register/Register'
import { usePath } from './router'

export default function App() {
  const path = usePath()
  return (
    <div>
      {path === '/thankyou' ? <Register /> : <Home />}
    </div>
  )
}
